import {
    ICONS_SEARCH_MODE,
    ICON_SETS_SEARCH_MODE,
    PHOTOS_SEARCH_MODE
} from "frontend/store/layout";

export const convertSearchModeToType = (searchMode = ICONS_SEARCH_MODE) => {
    switch (searchMode) {
        case ICONS_SEARCH_MODE:
            return "icons";
        case ICON_SETS_SEARCH_MODE:
            return "icon-collections";
        case PHOTOS_SEARCH_MODE:
            return "photos";
    }
};
